import React from 'react';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { Calendar } from 'primereact/calendar';
import { FileUpload } from 'primereact/fileupload';
import { Button } from 'primereact/button';
import { addHours, addYears } from 'date-fns';
import { CalendarPague, InputNumberPague } from '../../../../styles/primeReactConfig';

const TRES_MB_EM_BYTES = 3145728;

/**
 * Formulário utilizado para criação ou edição de lançamento avulso.
 */
export default function FormularioLancamentoAvulso({
                                                     lancamento,
                                                     setLancamento,
                                                     onSubmit,
                                                     isLoading,
                                                     modo = 'create',
                                                     uploadRef = null,
                                                     uploadImagem
                                                   }) {
  const tituloImagem = '(Resolução 550x310 | Tamanho máximo 3 Mb)';

  return (
    <form onSubmit={onSubmit}>
      <div className="flex flex-col gap-4 max-h-[80vh] overflow-y-auto">
        <div className="flex md:flex-row flex-col gap-4">
          <div className="w-full md:w-1/2 flex flex-col gap-2">
            <label>Descrição</label>
            <InputText
              value={lancamento.descricao}
              required
              onChange={(e) => setLancamento({ ...lancamento, descricao: e.target.value })}
            />

            <label>Valor</label>
            <InputNumber
              value={lancamento.valor || null}
              onValueChange={(e) => setLancamento({ ...lancamento, valor: e.value })}
              pt={InputNumberPague}
              placeholder="R$ 0,00"
              mode="currency"
              currency="BRL"
              locale="pt-BR"
              useGrouping={false}
              fractionDigits={2}
              required
            />
          </div>

          <div className="w-full md:w-1/2 flex flex-col gap-2">
            <label>Mês/Ano Referência</label>
            <Calendar
              pt={CalendarPague}
              value={lancamento.dataRef}
              onChange={(e) => setLancamento({ ...lancamento, dataRef: e.value })}
              view="month"
              dateFormat="mm/yy"
              yearNavigator
              yearRange={`${new Date().getFullYear()}:${addYears(new Date(), 10).getFullYear()}`}
              required
            />

            <label>Data de Vencimento</label>
            <Calendar
              pt={CalendarPague}
              value={lancamento.vencimento}
              onChange={(e) => setLancamento({ ...lancamento, vencimento: e.value })}
              placeholder="ex: 25/05/2022"
              dateFormat="dd/mm/yy"
              minDate={addHours(new Date(), 3)}
              required
            />
          </div>
        </div>

        <div>
          <label>Imagem para lançamento</label>
          <FileUpload
            name="file"
            accept=".png, .jpeg, .jpg, .jpe"
            customUpload
            uploadHandler={uploadImagem}
            auto
            onRemove={() => setLancamento((prev) => ({ ...prev, imagem: {} }))}
            maxFileSize={TRES_MB_EM_BYTES}
            invalidFileSizeMessageDetail="Sua imagem passou o limite de 3MB"
            ref={uploadRef}
          />
          <small><b>{tituloImagem}</b></small>
        </div>

        <div className="flex justify-center">
          <Button
            label={modo === 'edit' ? 'Atualizar' : 'Enviar'}
            type="submit"
            severity="success"
            loading={isLoading}
          />
        </div>
      </div>
    </form>
  );
}
